<template>
  <div class="bracket-container w-100 h-100">
    <EliminationBracket v-if="bracketStructure"></EliminationBracket>
    <!--<BattleRoyalBracket  v-if="tournmaentLoaded && bracketStructure"></BattleRoyalBracket>-->
    <div
      class="bracket-empty d-flex flex-column justify-content-center align-items-center px-2 w-100 h-100 mx-auto"
      v-else
    >
      <h6 class="no-results-msg mb-3">
        La liste des participants confirmés sera disponible<br />avant le début
        du tournoi.
      </h6>
      <br />
    </div>
  </div>
</template>

<script>
import EliminationBracket from "./EliminationBracket.vue";
//import BattleRoyalBracket from './BattleRoyalBracket.vue';
export default {
  name: "BracketViewer",
  components: {
    EliminationBracket,
    //BattleRoyalBracket
  },
  computed: {
    bracketStructure: {
      get() {
        return !!this.$store.state.currentTournament.tournamentItem?.bracket
          ?.structure;
        /*if(this.$store.state.currentTournament.tournamentItem){
                        return !!this.$store.state.currentTournament.tournamentItem.bracket.structure;
                    }
                    return false;*/
      },
    },
    tournmaentLoaded: {
      get() {
        return !!this.$store.state.currentTournament.tournamentItem;
      },
    },
  },
};
</script>
<style scoped>
.bracket-container {
  border: 1px solid var(--pink-variant);
}
.no-results-msg {
  font-family: "monsterrat", sans-serif;
  font-weight: 500;
  font-size: 18pt;
  color: rgb(82, 82, 82);
}
@media screen and (max-width: 768px) {
  .bracket-empty {
    background-size: 100% 45% !important;
    background-repeat: no-repeat;
  }
  .no-results-msg,
  .no-results-msg-arabic {
    font-size: 12pt;
  }
}
</style>
